<change-request-header-block [changeRequestVO]="changeRequestVO"></change-request-header-block>
<div class="grid-container">
<changes-requested-block *ngIf="changeRequestVO.id" [changeRequestVO]="changeRequestVO"></changes-requested-block>

<app-actions *ngIf="changeRequestVO?.actions" [changeRequestVO]="changeRequestVO" (reloadCrPage)="getInputData()"></app-actions>

<lib-users-list-block *ngIf="changeRequestVO?.unverifiedUsers?.length > 0" [unverifiedUsers]="changeRequestVO?.unverifiedUsers"></lib-users-list-block>

<authorizers-list-block [currentProcess]="changeRequestVO.process" [userInterFace]="true"
                        [authorizers]="changeRequestVO.authorizers"></authorizers-list-block>

<impacted-parties-tld-list *ngIf="changeRequestVO.requestMetadata && changeRequestVO.requestMetadata.impactedDomains" [currentDomainName]="changeRequestVO.tldName"
                           [domains]="changeRequestVO.requestMetadata.impactedDomains"></impacted-parties-tld-list>

<audit-log-block *ngIf="!changeRequestVO['V2'] && changeRequestVO.auditLog"  [auditLog]="changeRequestVO.auditLog" [changeRequestVO]="changeRequestVO"></audit-log-block>
</div>
